// Global
import React from 'react';

// Local
import { Content } from '@generated/Content/VerticalVideo.model';
import { VerticalVideoMain } from './VerticalVideo';
import { Data } from '@generated/Foundation.GMI.model';
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
import { Item } from '@sitecore-content-sdk/nextjs';
import { Themes } from 'lib/themes';
import { ComponentParams } from '@sitecore-content-sdk/nextjs';
import { PreambleOrientation } from 'components/helpers/Molecules/Preamble/Preamble';
import { EditingHelpText } from 'components/helpers/Editing/EditingHelpText';
import { usePreambleFields } from 'components/helpers/Molecules/Preamble/Preamble.sitecore';

type VerticalVideoProps = Content.VerticalVideo.VerticalVideo_Component & {
  params?: ComponentParams;
};

export const Default = (props: VerticalVideoProps) => {
  /*
   * Rendering
   */

  const { sitecoreContext } = useSitecoreContext();
  const preambleFields = usePreambleFields({
    fields: props.fields,
  });

  if (!props.fields) {
    return <></>;
  }

  // Map video items and get transcript URLs from sitecoreContext
  const videoListItems =
    props.fields.videoListItems?.map((videoItem: Item) => {
      const videoData = videoItem as Data.Content.Video;
      const videoId = videoData?.fields?.videoId?.value ?? '';
      const videoTranscriptFileUrl = sitecoreContext.videoTranscriptUrls?.[videoId] ?? '';

      return {
        fields: {
          videoId: videoData?.fields?.videoId?.value ?? '',
          videoHeadline: videoData?.fields?.videoHeadline?.value ?? '',
          videoDescription: videoData?.fields?.videoDescription?.value ?? '',
          videoThumbnail: videoData?.fields?.videoThumbnail?.value?.src ?? '',
          videoWithAudioDescriptionURL:
            videoData?.fields?.videoWithAudioDescriptionURL?.value ?? '',
          videoURL: videoData?.fields?.videoURL?.value ?? '',
          videoType: videoData?.fields?.videoType?.value ?? '',
          videoTranscriptFileUrl: videoTranscriptFileUrl,
        },
      };
    }) || [];

  if (videoListItems.length === 0) {
    return (
      <EditingHelpText priority="warning" componentName="Vertical Video Component">
        No video item selected. Have to select at least one video item in the VideoListItems
        dropdown to show the component.
      </EditingHelpText>
    );
  }

  return (
    <VerticalVideoMain
      theme={props.params?.theme as Themes}
      preambleOrientation={props.params?.preambleOrientation as PreambleOrientation}
      ariaLabel={props.fields.headline?.value || 'Vertical Videos'}
      contentListName={
        props.fields.headline?.value?.trim() || props.fields.headlineSubhead?.value?.trim() || ''
      }
      {...preambleFields}
      videoListItems={videoListItems}
    />
  );
};
